import { useEffect, useState } from "react";
import usePagination from "src/components/pagination/usePagination";
import useDataHandler from "src/components/data-handler/hooks/use-data-handler";
import useErrors from "src/hooks/useErrors";
import axiosInstance from "src/utils/axios";
import serializeDate from "src/utils/serialize-date";

const useConsultation = (filter) => {
  // const [dataList, setDataList] = useState([]);
  const handleErrors = useErrors();
  const [state, actions] = useDataHandler();
  const { count, onChange, page, seed, rowStart } = usePagination();

//    const filteredWatchValues = Object.fromEntries(
//   Object.entries(filter || {}).filter(([key, value]) => value !== "")
// );
  const fetchConsultationList = async (page = 1,filter) => {
    actions.loading();

    try {
      const { data ,status} = await axiosInstance.get(`/api/admin/health-consultation`, {
        params: {
          ...filter,
          page,
        },
      });
      if (status) {
      const {  data: members } = data.data;

        const { last_page, from } = data.data;
        seed(last_page, from);
        actions.success(members);
        return;
      }
      actions.success();
    } catch (err) {
      actions.error();
      handleErrors(err);
      
    }
  };

 
  useEffect(() => {
    const { start_date, end_date } = filter;
    fetchConsultationList(page, {
      ...filter,
      start_date: serializeDate(start_date),
      end_date: serializeDate(end_date),
    });
  }, [page]);

  return {
    state,
    fetchConsultationList,
    count,
    onChange,
    page,
    rowStart,
  };
};

export default useConsultation;
